import { render } from "./Login-form.vue?vue&type=template&id=8f9eecbe"
import script from "./Login-form.vue?vue&type=script&lang=js"
export * from "./Login-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__